



















import { Component, Prop, Vue } from 'vue-property-decorator';
import CardSliderArrowSvg from './CardSliderArrowSvg.vue';

@Component({
  components: {
    CardSliderArrowSvg,
  },
})
export default class CardSliderArrow extends Vue {
  @Prop({ type: String, default: '#8164a6' })
  public color!: string;

  mounted() {
    if (document) {
      document.addEventListener('keydown', this.keyPressd);
    }
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.keyPressd);
  }

  keyPressd(e: any): void {
    if (e.code === 'ArrowLeft') {
      this.changeImage('back');
    }

    if (e.code === 'ArrowRight') {
      this.changeImage('forward');
    }
  }

  changeImage(selector: string): void {
    this.$emit('changeImage', selector);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/images/components/CardSliderArrow.vue